export default __webpack_public_path__ + "static/media/seattleSeahawksVideo-2x.fe97f0ea.jpg";